import type {
  ClientDocumentItem,
  ClientDocumentItemPlaceHolder,
  ClientMediaItem,
  ClientMediaItemPlaceHolder,
  ClientTemporaryDocumentItem,
  ClientTemporaryMediaItem
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { DocumentPickerAsset } from 'expo-document-picker';
import type { ImagePickerAsset } from 'expo-image-picker';

export type ImagePickType = 'select' | 'take';

export type ImagePickerResult = {
  image: ImagePickerAsset;
  /**
   * Undefined when the temporary upload failed (e.g. the image stays above
   * the size limit even after compression). Callers should keep the entry
   * and let form validation flag it instead of silently dropping the pick.
   */
  temporaryMediaItem?: ClientTemporaryMediaItem;
};

export type DocumentPickerResult = {
  document: DocumentPickerAsset;
  temporaryDocumentItem: ClientTemporaryDocumentItem;
};

export type AvatarPickerResult = {
  logo?: ClientMediaItemPlaceHolder;
  temporaryMediaItemId?: string;
  localImage?: ImagePickerAsset;
};

/** Empty AvatarPickerResult — safe to use as a form default value. */
export const EMPTY_AVATAR_PICKER_RESULT: AvatarPickerResult = {
  logo: undefined,
  temporaryMediaItemId: undefined,
  localImage: undefined
};

export type MediaItemPlaceholder = Partial<ClientMediaItemPlaceHolder> & {
  mediaItem?: ClientMediaItem | undefined;
  localUri?: string | undefined;
};

export type DocumentItemPlaceholder = Partial<ClientDocumentItemPlaceHolder> & {
  documentItem?: ClientDocumentItem | undefined;
};
